import { useTranslation } from 'react-i18next'
import { useQueryParams, StringParam } from 'use-query-params'
import { useState, useEffect } from 'react'

import { useBreadcrumbs } from '../../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { MyTasksTable } from './myTasksTable/MyTasksTable'
import { useMyTasks } from './hooks/useMyTasks'
import { TableColumnSortDirection } from '@percent/lemonade'
import { createQueryParams } from './utils/utils'

export function MyTasksContainer() {
  const { t } = useTranslation()
  const [sortDirection, setSortDirection] = useState<TableColumnSortDirection>('ASC')
  const { tasks, isLoading, totalTasks, nextPage, previousPage, refresh, query } = useMyTasks(sortDirection)

  useBreadcrumbs([
    {
      label: t('breadcrumb.grants.myTasks')
    }
  ])

  const [, setQueryParams] = useQueryParams({
    direction: StringParam,
    searchTerm: StringParam,
    country: StringParam,
    program: StringParam,
    type: StringParam
  })

  useEffect(() => {
    query(createQueryParams(sortDirection))
  }, [sortDirection, query])

  const handleRequestSort = () => {
    const newDirection = sortDirection === 'ASC' ? 'DESC' : 'ASC'
    setSortDirection(newDirection)
    setQueryParams({ direction: newDirection })
  }

  return (
    <div data-testid="grants-my-tasks-container">
      <MyTasksTable
        data={tasks}
        isLoading={isLoading}
        totalResults={totalTasks}
        refresh={refresh}
        nextPage={nextPage}
        previousPage={previousPage}
        sortDirection={sortDirection}
        handleRequestSort={handleRequestSort}
        sortByColumn="deadline"
        filters={undefined}
      />
    </div>
  )
}
